<mat-toolbar [ngClass]="{'device-logger-style' : device && device.isDatalogger(), 'device-meter-style': device && device.isMeter()}">
  <span><a [routerLink]="['/device']" translate>DEVICE</a>&nbsp;</span>
  <span> / {{device && device.target ? device.target : ''}} @if (device && !device.target) {
    <span>{{device && device.name ? device.name : 'New Device'}}</span>
  }</span>
  @if (device) {
    <span class="badge ms-2" [ngClass]="{'text-bg-success': device.isOnline, 'text-bg-dark': !device.isOnline}">
      {{device.isOnline ? 'Online' : 'Offline'}}
    </span>
  }
  <span class="toolbar-spacer"></span>
  @if (device && device.parent && device.parent.id) {
    <button type="button" mat-raised-button color="primary" [routerLink]="['/device',device.parent.id]" class="ms-auto"> <mat-icon>settings_remote</mat-icon> Open Datalogger</button>
  }
  @if (device && device.company) {
    <button type="button" mat-raised-button color="primary" [routerLink]="['/networks',device.company.id]" class="ms-2"> <mat-icon>account_tree</mat-icon> View in tree</button>
  }
</mat-toolbar>

@if (device) {
  <mat-tab-group [ngClass]="{'device-logger-style' : device && device.isDatalogger(), 'device-meter-style': device && device.isMeter()}">
    @if (isAdmin) {
      <mat-tab label="Edit">
        <app-device-edit [device]="device" [configs]="configs" [types]="types"></app-device-edit>
      </mat-tab>
    }
    <mat-tab label="Overview" [disabled]="!device || !device.id">
      <app-meter-overview [item]="device" (deviceDataChange)="onDeviceDataChange($event)" [deviceData]="deviceData"></app-meter-overview>
    </mat-tab>
    <mat-tab label="Measurement" [disabled]="!device || !device.id">
      @if (device.isMeter()) {
        <app-device-measurement [device]="device" [isAdmin]="isAdmin" [deviceData]="deviceData" (deviceDataChange)="onDeviceDataChange($event)"></app-device-measurement>
      }
      @if (device.isDatalogger()) {
        <app-logger-measurement [device]="device" [servers]="servers"></app-logger-measurement>
      }
    </mat-tab>
    @if (device.isMeter()) {
      <mat-tab label="Data" [disabled]="!device || !device.id">
        <app-device-data></app-device-data>
      </mat-tab>
    }
    @if (device.isImpulse()) {
      <mat-tab label="Impulse" [disabled]="!device || !device.id">
        <app-device-impulse [device]="device"></app-device-impulse>
      </mat-tab>
    }
    <mat-tab label="Logs" [disabled]="!device || !device.id">
      <app-device-log [deviceID]="device.id"></app-device-log>
    </mat-tab>
  </mat-tab-group>
}
